"use client";
import creatPopupAtom, { PopupValue } from "@/utils/factory/createPopupAtom";
import { useAtom } from "jotai";

const usePopup = <TValue extends PopupValue>(
  atoms: ReturnType<typeof creatPopupAtom<TValue>>,
) => {
  const [popupValue] = useAtom(atoms.valueAtom);
  const [, handleOpenPopup] = useAtom(atoms.openAtom);
  const [, handleClosePopup] = useAtom(atoms.closeAtom);

  return { popupValue, handleOpenPopup, handleClosePopup };
};

export default usePopup;
